import { TFunction } from 'i18next';
import type { Category } from '@/api/types/categories.types';

export const sortOptions = (t: TFunction) => [
  {
    label: t('pages.shops.default'),
    value: 'default',
    dataStat: 'shops-order-default',
  },
  {
    label: t('pages.shops.by_count'),
    value: 'count',
    dataStat: 'shops-order-ads-count',
  },
  {
    label: t('pages.shops.by_popularity'),
    value: 'popularity',
    dataStat: 'shops-order-popularity',
  },
  {
    label: t('pages.shops.by_name'),
    value: 'name',
    dataStat: 'shops-order-name-asc',
  },
  {
    label: t('pages.shops.by_name_reverse'),
    value: 'name-reverse',
    dataStat: 'shops-order-name-desc',
  },
];

export function findCategoryInTree(
  categories: Category[] | null | undefined,
  selectedCategoryId: string
): Category | null {
  if (!categories?.length) return null;

  const stack: Category[] = [...categories];
  while (stack.length) {
    const current = stack.pop();
    if (!current) continue;
    if (current.id === selectedCategoryId) return current;
    if (current.children?.length) {
      stack.push(...current.children);
    }
  }

  return null;
}
